import React, { useState, useRef, useEffect } from "react";

export default function DropDownInFinanceReportComponentHeader({ label, options, selected, setSelected, labelKey, valueKey }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel =
    options.find((opt) => opt[valueKey] === selected)?.[labelKey] ||
    `Select ${label}`;

  return (
    <div ref={dropdownRef} className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>

      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="inline-flex w-full justify-between items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {selectedLabel}
        <svg
          className={`ml-2 h-5 w-5 text-gray-400 transition-transform duration-200 ${
            open ? "rotate-180" : ""
          }`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg border border-gray-200">
          <ul className="py-1 text-sm text-gray-700">
            {options.map((opt) => (
              <li key={opt[valueKey]}>
                <button
                  onClick={() => {
                    setSelected(opt[valueKey]);
                    setOpen(false);
                  }}
                  className={`block w-full text-left px-4 py-2 hover:bg-blue-100 hover:text-blue-700 ${
                    selected === opt[valueKey] ? "bg-blue-50 text-blue-600" : ""
                  }`}
                >
                  {opt[labelKey]}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
